/* Next */
import Link from 'src/components/Link'

/* Material */
import Card from '@mui/material/Card'
import Avatar from '@mui/material/Avatar'
import CardHeader from '@mui/material/CardHeader'

/* Material-Icons */
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LocalMallIcon from '@mui/icons-material/LocalMall'


import useStyles from './styles'
import config from 'src/config'
import { getNewsletterStorefront } from 'src/functions/newsletterStorefront'
import HomeyLoveDashboard from './HomeyLoveDashboard'

const Eingeloggt = () => {
  const classes = useStyles()

  if (getNewsletterStorefront(config.shop.shop)) return <HomeyLoveDashboard />

  return <div className={classes.root}>

    <AccountCard 
      href='account'
      title='Anmelden und Sicherheit'
      subheader="Ihre Anmeldedaten und verwalten"
      avatar={
        <Avatar aria-label="Anmelden und Sicherheit">
          <AccountCircleIcon />
        </Avatar>
      }
    />

    <AccountCard 
      href='bestellungen'
      title='Meine Bestellungen'
      subheader="Sendungen nachverfolgen und mehr"
      avatar={
        <Avatar aria-label="Meine Bestellungen">
          <LocalMallIcon />
        </Avatar>
      }
    />

  </div>
}

export default Eingeloggt

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

interface AccountCardProps {
  href: string
  title: string
  subheader: string
  avatar: React.ReactNode
}

const AccountCard = ({ href, title, subheader, avatar }: AccountCardProps) => 
  <Link href={`kundenkonto/${href}`} passHref legacyBehavior><a style={{
    textDecoration: 'none',
    color: 'inherit',
  }}>
    <Card>
      <CardHeader
        {...{title, subheader}}
        avatar={avatar}
      />
    </Card>
  </a></Link>

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */